export const getBackUrl = () => {
  const key = localStorage.getItem('key');
  return `/workflows/direct-mail/${key}/back`;
};

export const getNextUrl = () => {
  const key = localStorage.getItem('key');
  return `/workflows/direct-mail/${key}/next`;
};

export const getCheckinUrl = (aKey) => {
  const key = aKey || localStorage.getItem('key');
  return `/workflows/direct-mail/${key}/checkin`;
};
